import { getAppBar, getLocaleSwitch, useLocale } from "@dgs/core";
import { FC } from "react";
import { config } from "./config";
import { useConfig } from "./shared/hooks/useConfig";

const AppBar = getAppBar();
const LocaleSwitch = getLocaleSwitch();

export const PMApplicationBar: FC = () => {
	const { languageSettings, productData, brand } = useConfig();
	const { language, setLanguage } = useLocale();
	const brandLogoUrl = config.themeName === "dgs" ? brand?.logoFile.path : undefined;
	const logoUrl = productData.logoImage?.url ?? brandLogoUrl;

	return (
		<AppBar
			appIdentifier={productData.htmlTitle}
			logo={logoUrl ? { logoUrl, logoAltText: productData.logoImage?.alt || productData.htmlTitle || "" } : undefined}
		>
			<LocaleSwitch setLocale={setLanguage} locale={language} availableLocales={languageSettings.availableLanguages} />
		</AppBar>
	);
};
